import styles from '../TrainMachine.module.css'
import renderPrgImage from '../../../../source/programImg'
import { SpectrogramThumbnail } from './Spectrogram'

function SampleGrid({ samples, onRemove }) {
    return (
        <div style={{ marginTop: '30px' }}>
            <h5>Your Samples ({samples.length})</h5>
            <div
                className={styles.captureImagesDiv}
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    maxHeight: '350px',
                    overflowY: 'auto',
                    padding: '10px',
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    borderRadius: '10px',
                    maxWidth: '330px',
                    width: '330px',
                }}
            >
                {samples.map((s, i) => (
                    <div
                        key={s.id}
                        className={styles.sampleImgDiv}
                        style={{
                            width: '60px',
                            height: '60px',
                            backgroundColor: '#fff',
                            margin: '8px',
                            position: 'relative',
                            borderRadius: '8px',
                            border: '2px solid #3e74e0',
                        }}
                    >
                        <SpectrogramThumbnail data={s.sampleData} />
                        <img
                            src={renderPrgImage('eachImgCross')}
                            className={styles.imgDelete}
                            style={{
                                position: 'absolute',
                                top: "-5px",
                                right: "-5px"   ,
                                width: 20,
                                cursor: 'pointer',
                            }}
                            onClick={() => onRemove(s.id)}
                        />
                    </div>
                ))}
                {samples.length === 0 && (
                    <p
                        style={{
                            width: '100%',
                            textAlign: 'center',
                            color: '#888',
                            padding: '20px',
                        }}
                    >
                        No samples yet.
                    </p>
                )}
            </div>
        </div>
    )
}

export default SampleGrid
